export const getCareProvider = (state, id) => state.careProvider.careProviders.entries[id];
